
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/advocacy/international",
      function () {
        return require("private-next-pages/advocacy/international.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/advocacy/international"])
      });
    }
  